import { Box, Typography } from "@mui/material";
import Iconify from "./iconify/iconify";

export default function NoneFoundReport({padding}: {padding?: number}) {
  return <Typography component="div" color="error" padding={padding ?? 2}>
    <Box display="flex" gap={1}>
      <Iconify icon="octicon:alert-16" /> No Results Found
    </Box>
  </Typography>
}


